import DateRangeIcon from '@material-ui/icons/DateRange';

import List from './List';

export default {
  list: List,
  icon: DateRangeIcon,
};
